import {Component, EventEmitter, Injectable, Input, Output} from '@angular/core';
import {MatDialog} from '@angular/material';
import 'firebase/firestore';
import {ActivatedRoute, Router} from '@angular/router';
import {Campus} from '../../model/Campus';
import {GlobalService} from '../../services/global/global.service';
import {DataLoaderService} from '../../services/data-loader/data-loader.service';
import {Helper} from '../../model/Helper';
import {Building} from '../../model/BuildingData';

export interface SaveCampusPayload {
  campus: Campus;
}

export interface AddBuildingErrorPayload {
  message: string;
}

@Component({
  selector: 'app-edit-campus-information',
  templateUrl: 'edit-campus-information.component.html',
  styleUrls: ['edit-campus-information.component.css'],
})

@Injectable()
export class EditCampusInformationComponent {
  // View
  @Input() public campus: Campus;
  @Output() public saveCampus = new EventEmitter<SaveCampusPayload>();
  @Output() public addBuildingError = new EventEmitter<AddBuildingErrorPayload>();

  public newBuildingID: string;

  constructor() {
    this.newBuildingID = '';
  }

  public saveCampusClicked(): void {
    this.saveCampus.emit({
      campus: this.campus,
    });
  }

  public addBuildingClicked(): void {
    if (!Helper.IsValidIdentifier(this.newBuildingID)) {
      this.addBuildingError.emit({message: `Only use ${Helper.BuildingRegex} building names.`});
      return;
    } else if (Object.keys(this.campus.buildingData).includes(this.newBuildingID)) {
      this.addBuildingError.emit({message: `Building ${this.newBuildingID} already exists.`});
      return;
    } else {
      this.campus.buildingData[this.newBuildingID] = new Building({});
      this.newBuildingID = '';
    }
  }

  public removeBuildingClicked(id: string): void {
    delete this.campus.buildingData[id];
  }
}
